import SignUpLayout from "../../components/signup/layout";
import UploadImage from "../../components/signup/upload-national-image";
import { useLocation } from "react-router-dom";

export default function SignUpUploadImage() {
  const location = useLocation();

  return (
    <SignUpLayout
      type={location.pathname === "/signup/ngn/uploadImage" ? 40 : 0}
      step={3}
      steps={[2, 3, 4]}
    >
      <UploadImage  isShop={false}/>
    </SignUpLayout>
  );
}
